<template>
  <Layout>
    <!-- <PageHeader v-if="title" :title="title" :items="items" /> -->
    <balancing-payment-show-drawer ref="balancing-payment-show-drawer" @updated="refreshTable" @close="onDrawerClose"/>
    <balancing-payment-create id="balancing-payment-create-modal" @created="refreshTable" ref="balancing-payment-create-modal"/>

    <Loader :loading="loadingExport" no-axios>
      <div class="">
        <div v-if="stats.length" class="row">
          <div class="title">{{ lodash.upperCase(title) }}</div>
          <div v-for="stat of stats" :key="stat.icon" :class="stat.wrapperClass">
            <Stat v-bind="stat"/>
          </div>
        </div>
        <div v-if="!lodash.isEmpty(filterColumns)">
          <model-filter v-model="filter" :columns="filterColumns" :modelVariable="modelVariable"
                        :filterHandler="filterHandler"/>
        </div>
      </div>
      <div class="title">
        {{ lodash.upperCase($t('List')) }} {{ lodash.upperCase(title) }}
      </div>
      <div class="row">
        <model-index ref="table" class="col-12" :loading="loading" v-bind="$props" :columns="columns" :busy.sync="busy"
                     :models-paginated="modelsPaginated" :page.sync="page" :per-page.sync="perPage" :from="from"
                     :total="totalFiltered" :search.sync="search" :sort-by.sync="sortBy" :sort-desc.sync="sortDesc"
                     :filter-params.sync="filterParams" @create-click="handleCreate" @export-click="handleExport"
                     @show-click="handleShow" @edit-click="handleEdit" @delete-click="handleDelete">
        </model-index>
      </div>
    </Loader>
  </Layout>
</template>

<script>
import ModelFilter from '@/router/views/balancing_payments/filter'
import ModelIndex from "../models/index-v3"
import icons from '@/assets/icons';
import DownPaymentFormExport from '@/components/modals/down-payment-form-export'
import JalaAppIcon from '@/assets/icons/JalaApp.svg'
import JalaHarvestIcon from '@/assets/icons/JalaHarvest.svg'
import JalaProIcon from '@/assets/icons/JalaPro.svg'
import StatusWidget from '@/components/widgets/statuses/status'
import StatusTonWidget from '@/components/widgets/statuses/status-with-ton'
import StatusDateWidget from '@/components/widgets/statuses/status-with-date'
import DriverCreateModal from "@/components/modals/driver-create.vue";
import BalancingPaymentCreate from "@/components/modals/balancing-payment-create.vue";
// import BalancingShowDrawer from "@/components/drawers/balancing-show-drawer.vue";
import BalancingPaymentShowDrawer from "@/components/drawers/balancing-payment-show-drawer.vue";
/* eslint-disable vue/no-unused-components */
export default {
  extends: ModelIndex,
  components: {
    // BalancingShowDrawer,
    BalancingPaymentShowDrawer,
    BalancingPaymentCreate,
    DriverCreateModal,
    ModelFilter,
    DownPaymentFormExport,
    icons,
    JalaAppIcon,
    JalaHarvestIcon,
    JalaProIcon,
    StatusWidget,
    StatusTonWidget,
    StatusDateWidget,
  },
  page: {
    title: "Purchase Orders",
  },
  props: {
    resourceRoute: {default: 'balancing_payments'},
    modelVariable: {default: 'balancing_payments'},
    denyCreate: {
      type: Boolean, default() {
        return false;
      }
    },
    tableProps: {
      default(){
        return {
          "tbody-tr-class": function(item, type){
            if(!item || !type) return;
            if(item._highlight){
              return 'table-row-highlight';
            }
          }
        }
      }
    }
  },
  data() {
    return {
      title: this.lodash.startCase(this.$t('balancing_payments.plural')),
      items: [
        {
          text: this.lodash.startCase(this.$t('balancing_payments.singular')),
          href: "/balancing_payments",
          active: true,
        },
      ],
      sortBy: (this.$route.query.sort && this.$route.query.sort.split('|').shift().split(',').shift()) || 'id',
      sortDesc: (this.$route.query.sort && this.$route.query.sort.split('|').shift().split(',').pop() === 'desc') || true,
      filterColumns: {
        'ticket.customer_type': {
          type: String,
          label: this.lodash.upperFirst(this.$t('balancings.customer_type')),
          placeholder: "Pilih " + this.lodash.upperFirst(this.$t('balancings.customer_type')),
          operator: 'in',
          input_component: 'customer-type-select',
        },
        id__in: {
          type: Array,
          label: this.lodash.upperFirst(this.$t('balancing_payments.id')),
          params: {
            sort: 'id,desc',
            select: 'id',
          },
          placeholder: "Pilih " + this.lodash.upperFirst(this.$t('balancing_payments.id')),
          operator: 'in',
          input_component: 'balancing-payment-multiselect-ajax',
          searchKey: 'id',
        },
        shrimp_id__in: {
          type: Array,
          label: this.lodash.upperFirst(this.$t('products.singular')),
          placeholder: "Pilih " + this.lodash.upperFirst(this.$t('products.singular')),
          operator: 'in',
          input_component: 'product-service-multiselect-ajax',
          params: {
            customer_type__contains: 'lcs',
          },
        },
        paid_at__between: {
          type: Array,
          label: this.lodash.upperFirst(this.$t('balancing_payments.paid_at')),
          placeholder: "Pilih " + this.lodash.upperFirst(this.$t('balancing_payments.paid_at')),
          operator: 'between',
          input_component: 'datepicker-range',
        },
        customer_id__in: {
          type: Array,
          label: this.lodash.upperFirst(this.$t('purchase_orders.partner')),
          placeholder: "Pilih " + this.lodash.upperFirst(this.$t('purchase_orders.partner')),
          operator: 'in',
          input_component: 'supplier-multiselect-ajax',
        },
        'payment_status': {
          type: String,
          label: this.lodash.startCase('Status Pembayaran'),
          placeholder: "Pilih " + this.lodash.startCase('Status Pembayaran'),
          input_component: 'balancing-payment-status-select',
        },
      },
      model: this.modelVariable
    }
  },
  computed: {
    columns() {
      return {
        ['balancing_payments']: [
          {
            key: 'balancing_transaction.sale_order.ticket_id',
            label: this.lodash.startCase(this.$t('balancing_payments.ticket_id')),
            thStyle: {minWidth: '100px'},
            tdClass: 'align-middle',
            sortable: true,
            component: {
              props: ['item'],
              computed: {
                customLabel() {
                  const ticket = this.item.balancing_transaction.sale_order.ticket;
                  return `${ticket.id}: ${this.$t(`tickets.customer_types.${ticket.customer_type}`)}`;
                }
              },
              template: '<router-link :to="`/tickets/${item.balancing_transaction.sale_order.ticket_id}`">{{ customLabel }}</router-link>'
            }
          },
          {
            key: 'id',
            label: this.lodash.startCase(this.$t('balancing_payments.id')),
            thStyle: {minWidth: '140px'},
            tdClass: 'align-middle',
            sortable: true,
          },
          {
            key: 'invoice_number',
            label: this.lodash.startCase(this.$t('balancing_payments.purchase_reference')),
            thStyle: {minWidth: '140px'},
            tdClass: 'align-middle',
            sortable: true,
            component: {
              props: ['item'],
              computed:{
                hasKmtbService(){
                    return this.item.balancing_transaction?.sale_order?.trip?.is_km_service;
                },
                invoices(){
                  if(this.hasKmtbService) {
                      return this.item.invoice_number;
                  }
                  const ids = this.item.balancing_transaction.sale_order.sale_items
                      .map(item => (
                          item.purchase_item.purchase_order.paymentables
                              .map(paymentable => paymentable.payment.invoice_number)
                      )).flat().filter((id) => !!id);
                  const uniqueIds = [...new Set(ids)];
                  if(uniqueIds.length === 0){
                    return '-';
                  }
                  return uniqueIds.join(', ');
                }
              },
              template: `<div>{{invoices}}</div>`
            }
          },
          {
            key: 'paid_at',
            label: this.lodash.startCase(this.$t('sale_invoices.paid_at')),
            thStyle: {minWidth: '180px'},
            tdClass: 'align-middle',
            sortable: true,
            formatter: value => this.$moment.utc(value).local().format('DD MMMM YYYY'),
          },
          {
            key: 'purchase_items',
            label: this.lodash.startCase(this.$t('balancing_payments.purchase_order_ids')),
            thStyle: {minWidth: '180px'},
            tdClass: 'align-middle',
            sortable: true,
            component: {
              props: ['item'],
              computed:{
                purchaseOrderIds(){
                  const ids = this.item.balancing_transaction.sale_order.sale_items.map(item => item.purchase_item.purchase_order_id);
                  const uniqueIds = [...new Set(ids)];
                  return uniqueIds.join(', ');
                }
              },
              template: `<div>{{purchaseOrderIds}}</div>`
            }
          },
          {
            key: 'to_bank_account',
            label: this.lodash.startCase(this.$t('sale_invoices.to')),
            thStyle: {minWidth: '180px'},
            tdClass: 'align-middle',
            sortable: true,
            component: {
              props: ['item'],
              template: '<router-link :to="`/customers/${(item || {}).to_bank_account.customer_id}`">{{ `${item.to_bank_account.customer.name } - ${ item.to_bank_account.account_number} - ${item.to_bank_account.bank.name}` }}</router-link>'
            }
          },
          {
            key: 'balancing_transaction.total_debt',
            label: this.lodash.startCase(this.$t('balancing_payments.nominal')),
            style: { minWidth: '160px' },
            thClass: "text-center",
            tdClass: "text-end align-middle",
            sortable: true,
            formatter: (value) => {
              return this.$numeral(value).format('$ 0,0.[00]');
            }
          },
          {
            key: 'creator.name',
            label: this.lodash.startCase(this.$t('CreatedBy')),
            thStyle: { minWidth: '50px' },
            style: { width: '20%' },
            tdClass: 'align-middle',
            formatter: (value) => this.lodash.startCase(value)
          },
          {
            key: 'status',
            label: this.lodash.startCase(this.$t('balancing_payments.status')),
            thStyle: {minWidth: '180px'},
            tdClass: 'align-middle',
            formatter: (value) => this.lodash.startCase(value),
            component: {
              props: ['item'],
              computed: {
                status() {
                  const remaining_debt = this.item.balancing_transaction.remaining_debt
                  if (remaining_debt === 0) return this.lodash.upperFirst(this.$t('paid off'))
                  return remaining_debt > 0 ?
                      this.lodash.upperFirst(this.$t('underpaid {nominal}', {nominal: `<br>${this.$numeral(remaining_debt).format('$ 0,0.[00]')}`})) :
                      this.lodash.upperFirst(this.$t('balancing_payments.overpaid {nominal}', {nominal: `<br>${this.$numeral(Math.abs(remaining_debt)).format('$ 0,0.[00]')}`}))
                },
                style(){
                  const remaining_debt = this.item.balancing_transaction.remaining_debt
                  if (remaining_debt === 0) return 'text-success'
                  return remaining_debt > 0 ? 'text-warning' : 'text-success'
                }
              },
              template: '<span v-html="status" :class="style"></span>'
            }
          },
        ],
      };
    },
  },
  methods: {
    handleCreate(){
      this.$refs["balancing-payment-create-modal"].open({})
    },
    refreshTable(){
      this.$refs.table.$refs.table.refresh()
    },
    handleShow(value) {
      this.clearHighlight();
      const modelIndex = this.models?.findIndex((model) => model.id === value.id);
      if(modelIndex !== -1){
        this.$set(this.models[modelIndex], '_highlight', true);
      }
      this.$refs["balancing-payment-show-drawer"].show(value.id);
    },
    clearHighlight(){
      this.models?.filter((model) => model._highlight).forEach((model) => this.$set(model, '_highlight', false));
    },
    onDrawerClose(){
      setTimeout(() => {
        if(!this.$refs["balancing-payment-show-drawer"].open){
          this.clearHighlight();
        }
      }, 300)
    },
    getModelName(value) {
      return value['id'];
    },
    fetchModels(page = 1) {
      return this.$axios.get('/balancing_payments', {
        params: {
          page: page,
          per_page: this.perPage,
          search: this.search,
          withAggregate: true,
          with: [
            'balancing_transaction',
            'balancing_transaction.sale_order',
            'balancing_transaction.sale_order.ticket',
            'balancing_transaction.sale_order.trip',
            'balancing_transaction.customer',
            'balancing_transaction.profit_share',
            'balancing_transaction.manufacture',
            'balancing_transaction.sale_order.sale_items.purchase_item.purchase_order.paymentables.payment',
            'from_bank_account.bank',
            'from_bank_account.customer',
            'to_bank_account.bank',
            'to_bank_account.customer',
            'creator',
          ].join(','),
          sort: `${this.sortBy},${this.sortDesc ? 'desc' : 'asc'}`,
          ...this.$route.params,
          ...this.filterParams
        }
      }).then((response) => {
        const {data: {data, meta}} = response;

        this.models = data.map((datum) => {
          return {
            ...datum,
            // _denyShow: true,
          }
        })

        this.$nextTick(() => {
          const {
            balancing_payment_show__id,
          } = this.$route.query;
          if(balancing_payment_show__id){
            this.handleShow({
              id: balancing_payment_show__id
            })
          }
        })

        this.page = Number(meta.current_page);
        this.perPage = Number(meta.per_page);
        this.from = Number(meta.from);
        this.total = Number(meta.total);
        // this.stats = [
        //   {
        //     title: this.lodash.startCase(this.$t('balancing_payments.count')),
        //     value: this.$numeral(meta.total).format('0,0 a'),
        //     valueTitle: this.$numeral(meta.total).format('0,0'),
        //     wrapperClass: 'col-12 col-md-6 col-xl-4',
        //     component: StatusWidget,
        //   },
        // ]
        return response;
      }).catch((error) => this.failedAlert(error));
    },
  },
  mounted() {
    // check if balancing transaction id is present on query params
    const {
      balancing_payment_create__balancing_transaction_id,
    } = this.$route.query;
    if (balancing_payment_create__balancing_transaction_id) {
      this.$refs["balancing-payment-create-modal"].open({
        balancing_transaction_id: balancing_payment_create__balancing_transaction_id
      })
    }
    // if (balancing_payment_show__balancing_transaction_id) {
    //
    // }

  }
};
</script>

<style scoped lang="scss">
::v-deep {
  .page-content {
    background: #EEF3F7 !important;
    font-family: Lato;
    color: #161B4D;
  }

  .text-right {
    text-align: right;
  }
}

</style>
<style>
body {
  max-width: 100vw !important;
  overflow-x: hidden !important;
}

.highlighted-row {
  background: #EEF3F7;
}

.highlighted-separator {
  border-bottom: 1px solid #1B77DF;
  position: relative;

  .separator-badge {
    &::before {
      content: 'baru ditambahkan';
      position: absolute;
      bottom: -22px;
      border-radius: 0px 0px 4px 4px;
      background: #1B77DF;
      color: white;
      text-align: center;
      padding: 2px 5px;
    }
  }
}

.highlighted-separator-badge {
  position: absolute;
  top: 100px;
  left: 100px;
  background: blue;
}

</style>

<style lang="scss" scoped>
  ::v-deep {
    .table-model {
      thead {
        tr th {
          color: var(--neutral-700, var(--colors-slate-700, #334155));
          font-size: 13px;
          font-style: normal;
          font-weight: 600;
          line-height: 18px; /* 138.462% */
        }
      }

      .table-row-highlight{
        background: #F1F5F9;
      }

      tbody tr {
        *{
          font-size: 14px !important;
        }
      }
    }
  }
</style>